/**
 * @desc getExpenseReimbursementList
 */
const URL = "/rantion-rms";
import http, { updateResponse } from "@/http";
export type Response = defs.rms.ResponseDto<Array<defs.rms.ExpenseReimbursementResponseDto>>;
export function request(
  params: API.rms.expenseReimbursementFacadeImpl.getExpenseReimbursementList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/expenseReimbursement/getExpenseReimbursementList`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
